var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import CustomerService from "../../Customer/services/CustomerService";
import Profile from "../../Customer/components/Profile";
import Notification from "../../App/components/Notification";
import { handleServiceError } from "../../App/components/ErrorHandler";
export default function EditProvider() {
    var _a = useState(), customer = _a[0], setCustomer = _a[1];
    var _b = useState(), user = _b[0], setUser = _b[1];
    var location = useLocation();
    var params = useParams();
    var userId = params.id;
    useEffect(function () {
        providerData(userId);
    }, [userId]);
    function updateCustomer(updatedCustomer) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Notification().Loading.dots("Carregando");
                        return [4 /*yield*/, CustomerService.update(updatedCustomer.id, updatedCustomer).then(function (res) {
                                Notification().Loading.remove();
                                Notification().Notify.success("Provedor ".concat(res.data.customer.name, ", atualizado com sucesso!"));
                            }, function (err) {
                                Notification().Loading.remove();
                                if (err.response.status === 403) {
                                    Notification().Notify.failure("Usuário não tem permissão para executar essa ação!");
                                }
                                else {
                                    Notification().Notify.failure(err.response.data.error);
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    ;
    function providerData(customerId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Notification().Loading.dots("Carregando");
                CustomerService.find(customerId).then(function (res) {
                    setCustomer(res.data.customer);
                    setUser(res.data.customer.main_user);
                    Notification().Loading.remove();
                }, function (err) {
                    handleServiceError(err);
                });
                return [2 /*return*/];
            });
        });
    }
    ;
    if (!customer || !user || customer.billing_email === "" || user.id === 0) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(Profile, { customer: customer, user: user, callbackAction: updateCustomer, status: location.state.status, providerData: providerData }));
}
